var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_forward_24px",
    d: "M10.0002 3.3335L8.82516 4.5085L13.4752 9.16683H3.3335V10.8335H13.4752L8.82516 15.4918L10.0002 16.6668L16.6668 10.0002L10.0002 3.3335Z",
    fill: "#4D7EFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrow-forward.a3e31d1a908173c575c2cd5f11199dd2.svg";
export { ForwardRef as ReactComponent };